import { MainSettingsContent } from './main-settings-content';

export { MainSettingsContent };
